import React, { useEffect, useState } from "react";
import Title_Section from "../../../components/Title_Section/Title_Section";
import { Grid } from "@mui/material";
import Button from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../assets/locale/messages";
import AddIcon from "@material-ui/icons/Add";
import TopicsForm from "./TopicsForm";
import { add } from "../../../store/ActionsBtn/actions";
import TopicsList from "./TopicsList";
import { find } from "lodash";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Form, Formik } from "formik";
import Search from "../../../components/Search";
import {
  getAllFlashCardSubTopicsRequest,
  getAllFlashCardTopicsRequest
} from "../../../store/FlashCard/Topics/actions";
import Pagination from "../../../components/Pagination";
function Topics() {
  const dispatch = useDispatch();
  const { topicId } = useParams(); // This will be undefined on the main topics page
  const isSubTopic = Boolean(topicId);
  const isAdd = useSelector((state) => state.actionsBtn.add);
  const editId = useSelector((state) => state.actionsBtn.edit);
  const { list, subTopicsList, meta } = useSelector(
    (state) => state.flashCardTopics
  );
  const perPage = 10;
  const selectedTopic = find(list, ["id", editId]);
  const selectedSubTopic = find(subTopicsList, ["id", editId]);
  const lang = useSelector((state) => state.locale.lang);
  console.log("isSubTopic", isSubTopic);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const {
    flashcard: {
      topic: { title, addTitle },
      subTopic: { title: subtitle, addTitle: addSubTitle }
    }
  } = messages[lang];
  const handleAddTopics = () => {
    dispatch(add(true));
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1); // reset to first page on new search
  };
  // Single shared fetch function
  const fetchList = (pageNumber, searchValue) => {
    const baseParams = {
      page: pageNumber,
      items: perPage,
      paginate: true,
      name: searchValue || ""
    };

    isSubTopic
      ? dispatch(
          getAllFlashCardSubTopicsRequest({ ...baseParams, topicId })
        )
      : dispatch(getAllFlashCardTopicsRequest(baseParams));
  };
  // Re-fetch when page, search, or topicId changes
  useEffect(() => {
    fetchList(page, search);
  }, [page, search, topicId]);

  const handlePagination = (event, newPage) => {
    setPage(newPage);
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={isSubTopic ? subtitle : title} />
      </div>
      <Grid container spacing={3} marginBottom={1}>
        <Grid item xs={5}>
          <Formik initialValues={{ search: "" }}>
            {() => (
              <Form>
                <Search
                  name="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
              </Form>
            )}
          </Formik>
        </Grid>
        <Grid
          item
          xs={7}
          className="d-flex align-items-start justify-content-end"
        >
          <Button
            text={isSubTopic ? addSubTitle : addTitle}
            icon={<AddIcon className="me-2" />}
            onClick={handleAddTopics}
          />
        </Grid>
      </Grid>
      <TopicsList isSubTopic={isSubTopic} lang={lang} />
      <TopicsForm
        isSubTopic={isSubTopic}
        mode={editId ? "edit" : "add"}
        selectedTopicOrSubTopic={
          isSubTopic ? selectedSubTopic : selectedTopic
        }
        isOpen={isAdd || editId ? true : false}
        lang={lang}
      />
      {meta.pages > 1 && (
        <Pagination
          count={meta.pages}
          page={meta.currentPage || page}
          handleChange={handlePagination}
        />
      )}
    </>
  );
}

export default Topics;
